import React from "react";

export const Choose = (props) => {
  return (
    <div id="choose">
      <div className="intro">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-12 col-md-offset-1">
            <div className="choose-text">
              <h2>Why Choose Us?</h2>
              <div className="list-style">
                <div className="col-lg-12 col-sm-12 col-xs-12">
                    <ul>
                      <li>End-to-End expertise : From initial consultation to long-term upkeep, we handle it all.</li>
                      <li>Compliance Focused : Systems that meet international security standards and regulations.</li>
                      <li>Technology Driven : Systems that meet international security standards and regulations.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
    </div>
  );
};
